import Vue from 'vue'

const GkConfirmDirective = Vue.directive('gkConfirm', {
  bind (el, binding) {
    if (binding.value.callback && !isCallbackFn(binding.value.callback)) {
      throw "callback is not a function."
    }
    el.addEventListener('click', (e) => {
      e.stopPropagation()

      const Constructor = Vue.options.components['confirm-modal']

      // Get the value passed to the directive
      const { title, message, options } = binding.value

      // Instantiate the component with the passed props
      const componentInstance = new Constructor({
        propsData: { title, message, options }
      })

      // Mount the component
      componentInstance.$mount()

      // Append it to the body
      document.body.appendChild(componentInstance.$el)

      componentInstance.$on('confirmed', (data) => {
        if (binding.value.callback) {
          binding.value.callback(binding.value.callbackParams)
        }
        if (componentInstance && componentInstance.$el.parentNode) {
          componentInstance.$el.parentNode.removeChild(componentInstance.$el)
        }
      })

      componentInstance.$on('cancel', () => {
        if (componentInstance && componentInstance.$el.parentNode) {
          componentInstance.$el.parentNode.removeChild(componentInstance.$el)
        }
      })
    })
  }
})

function isCallbackFn(fn) {
  return fn && {}.toString.call(fn) === '[object Function]';
}

export default GkConfirmDirective